import { C as CosmosText$1, d as defineCustomElement$1 } from './p-0f8558ea.js';

const CosmosText = CosmosText$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosText, defineCustomElement };
